export default __webpack_public_path__ + "static/media/Van15.8faeddc1.webp";